module.exports = __webpack_public_path__ + "static/media/1cdca10a-9303-4960-84d9-8bb23272630c.96658c75.jpg";